import serializePath from '@spa/lib/router/serializePath';
import { useMemo } from 'react';
import { usePathname } from 'next/navigation';
import useRuntimeSearchParams from './useRuntimeSearchParams';

export interface FullPathResult {
  readonly pathname: string;
  readonly searchParams: URLSearchParams;
  readonly fullPath: string;
}

const useFullPath = (): FullPathResult => {
  const pathname = usePathname();
  const searchParams = useRuntimeSearchParams();

  return useMemo(() => {
    const fullPath = serializePath(pathname, searchParams);
    return {
      pathname,
      searchParams,
      fullPath
    };
  }, [pathname, searchParams]);
};

export default useFullPath;
